import { Pipe, PipeTransform } from '@angular/core';
import { escapeHtmlString } from '@app/modules/pipes/pipes/escape-html/escape-html-string.util';

@Pipe({
    name: 'escapeHtml',
    standalone: false
})
export class EscapeHtmlPipe implements PipeTransform {
    public transform(value: string): string {
        return escapeHtmlString(value);
    }
}
